if (!customElements.get("m-unik-text-features")) {
  class MUnikTextFeatures extends HTMLElement {
    constructor() {
      super();

      this.enableSlider = this.dataset.enableSlider === "true";
      this.items = this.dataset.items;
      this.showPagination = this.dataset.showPagination === "true";
      this.showNavigation = this.dataset.showNavigation === "true";
      this.slideContainer = this.querySelector(".swiper-container");
    }

    connectedCallback() {
      this.lastActive = null;
      if (this.enableSlider && this.slideContainer) this.initSlider();
    }

    initSlider() {
      const controlsContainer = this.querySelector(".m-slider-controls");
      const prevButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-prev");
      const nextButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-next");
      const slideItemsLength = this.querySelector(".swiper-wrapper").childElementCount;
      let __this = this;

      this.slider = new MinimogLibs.Swiper(this.slideContainer, {
        slidesPerView: 1.2,
        spaceBetween: 10,
        navigation: this.showNavigation,
        loop: true,
        slidesPerGroup: 1,
        pagination: this.showPagination
          ? {
              el: this.querySelector(".swiper-pagination"),
              clickable: true,
            }
          : false,
        breakpoints: {
          480: {
            slidesPerView: 2,
            spaceBetween: 15,
          },
          768: {
            slidesPerView: Math.max(1, parseInt(this.items) - 1),
            spaceBetween: 20,
          },
          1280: {
            slidesPerView: parseInt(this.items),
            spaceBetween: 30,
          },
        },
        on: {
          init: function () {
            if (__this.lastActive !== null) this.slideToLoop(__this.lastActive);
            setTimeout(() => {
              // Calculate controls position
              const firstItem = __this.querySelector(".utf-card");
              const controlsContainer = __this.querySelector(".m-slider-controls");
              if (firstItem && controlsContainer) {
                const itemHeight = firstItem.clientHeight;
                const offsetTop = parseInt(itemHeight) / 2;
                controlsContainer.style.setProperty("--offset-top", offsetTop + "px");

                const prevButton = controlsContainer.querySelector(".m-slider-controls__button-prev");
                const nextButton = controlsContainer.querySelector(".m-slider-controls__button-next");
                if (prevButton) prevButton.classList.remove("m:hidden");
                if (nextButton) nextButton.classList.remove("m:hidden");
                
                console.log(`[MUnikTextFeatures] offsetTop calculated: ${offsetTop}px`);
              }
            }, 300);
          },
          breakpoint: (swiper, breakpointParams) => {
            if (controlsContainer) {
              const { slidesPerView } = breakpointParams;
              if (slideItemsLength > slidesPerView) {
                controlsContainer.classList.remove("m:hidden");
                swiper.allowTouchMove = true;
              } else {
                controlsContainer.classList.add("m:hidden");
                swiper.allowTouchMove = false;
              }
            }
          },
        },
      });

      if (this.slider && this.showNavigation) {
        prevButton && prevButton.addEventListener("click", () => this.slider.slidePrev());
        nextButton && nextButton.addEventListener("click", () => this.slider.slideNext());
      }
      
      this.addEventListener("shopify:block:select", (e) => this.onBlockSelect(e));
    }

    onBlockSelect(e) {
      const block = e.target;
      const index = Number(block.dataset.slide);
      this.lastActive = index;
      if (this.slider) {
        this.slider.slideToLoop(index);
      }
    }
  }

  customElements.define("m-unik-text-features", MUnikTextFeatures);
}
